module.exports = "/images/no.svg?fb11fb42795e2d7f256e4daf068e7940";